import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { SpinnerService } from './components/core/_infrastructure/classes/services/spinner.service';
import { AuthService } from './components/core/_infrastructure/classes/services/auth.service';
import { BroadcastService } from './components/core/_infrastructure/classes/services/broadcast.service';
import { Observable, Subscription } from 'rxjs';
import { NotificationService } from './components/core/_infrastructure/classes/services/notification.service';
import { BroadcastTypes } from './components/core/_infrastructure/types/broadcast';
import { Router } from '@angular/router';
import { AUTH_GRANT_TYPE_ENUM } from './components/core/_infrastructure/types/common';
import { Loading } from './components/core/_infrastructure/types/utils';
import { BROADCAST_SERVICE } from './app.module';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
    @HostListener('window:unload', ['$event'])
    forceCheckUnload(): boolean {
        this.subscription.unsubscribe();
        return false;
    }

    title = 'CexVeg';
    subscription = new Subscription();

    constructor(
        @Inject(BROADCAST_SERVICE) private broadcastService: BroadcastService,
        private router: Router,
        private authService: AuthService,
        private spinnerService: SpinnerService,
        private config: PrimeNGConfig,
        protected notificationService: NotificationService,
    ) {
        // DO NOTHING
    }

    ngOnInit() {
        this.config.setTranslation({
            dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
            dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
            dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
            monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
            today: 'Hoy',
            clear: 'Borrar',
            //translations
        });

        const mainLoading = document.querySelector<HTMLElement>('.main-loading-indicator')!;
        if (mainLoading && mainLoading?.['style']) {
            mainLoading['style'].display = 'none';
        }

        this.subscribeToBroadcast();
    }

    private broadcastLogin(): void {
        this.broadcastService.publish({
            type: BroadcastTypes.LOGIN,
        });
    }

    private subscribeToBroadcast(): void {
        this.subscription.add(
            this.authService.login$.subscribe((grantType: string) => {
                switch (grantType) {
                    case AUTH_GRANT_TYPE_ENUM.REFRESH_TOKEN:
                    case AUTH_GRANT_TYPE_ENUM.REFRESH_ACLAVE:
                        return;
                }
                this.broadcastLogin();
            }),
        );

        // https://acagroup.be/en/blog/how-to-use-the-broadcastchannel-api-angular/
        // Para cerrar sesiones en otras pestañas abiertas del navegador.
        // Sigue un patrón productor-consumidor, donde el productor (misma pestaña del navegador),
        // aún estando subscrito, no recibe sus propios mensajes emitidos.
        // Si los recibirán los consumidores (otras pestañas del navegador)
        this.subscription.add(
            this.broadcastService.messagesOfType(BroadcastTypes.LOGOUT).subscribe(() => {
                // Se ha detectado un logout en otra PESTAÑA, se recarga la pantalla.
                this.notificationService.addSuccessMessage('Sesión finalizada');
                this.router.navigate(['/logout']);
                setTimeout(() => {
                    window.location.reload();
                }, 0);
            }),
        );
        this.subscription.add(
            this.broadcastService.messagesOfType(BroadcastTypes.LOGIN).subscribe(() => {
                // Se ha detectado un login en otra PESTAÑA, se recarga la pantalla.
                this.notificationService.addSuccessMessage('Sesión iniciada');
                this.router.navigate(['/home']);
                setTimeout(() => {
                    window.location.reload();
                }, 0);
            }),
        );
        this.subscription.add(
            this.broadcastService.messagesOfType(BroadcastTypes.ERROR).subscribe(() => {
                // Se ha detectado un login en otra PESTAÑA, se recarga la pantalla.
                this.notificationService.addErrorMessage('Error de autorización');
                this.router.navigate(['/error/loginko']);
                setTimeout(() => {
                    window.location.reload();
                }, 0);
            }),
        );
    }

    get getLoadingStatus(): Observable<Loading> {
        return this.spinnerService.getLoadingStatus();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
